import { itemsFetchActionHandler } from "./stock/items/items";
import { fetchStockAssets } from "./stock/assets/assets";
import { fetchStockProductList } from "./stock/productList/productList";
import { fetchItemsList } from "./stock/itemsList/itemsList";

import { distributionFetchActionHandler } from "./stock/distribution/distribution";
import {
  fetchEmployees,
  fetchEmployee,
  fetchEmployeeGeneralInfoActionHandler,
  fetchEmployeeAssetsActionHandler,
  assignEmployeeDeskOrBedActionHandler,
} from "./employee/employee";
import { fetchAssets } from "./asset/asset";
import {
  fetchRequisitions,
  createRequisition,
  fetchRequisition,
  approveRequisition,
  assignRequisition,
} from "./requisition/requisition";

import {
  groupFetchActionHandler,
  groupCreateActionHandler,
  groupUpdateActionHandler,
  groupDeleteActionHandler,
  groupFetchByIdActionHandler,
} from "../inventory/settings/group";

import {
  categoryListActionHandler,
  updateCategoryActionHandler,
  deleteCategoryActionHandler,
  createCategoryActionHandler,
  fetchCategoryByIdActionHandler,
} from "../inventory/settings/category";

import {
  conditionListActionHandler,
  updateConditionActionHandler,
  deleteConditionActionHandler,
  createConditionActionHandler,
} from "./settings/condition";

import {
  brandFetchActionHandler,
  brandCreateActionHandler,
  brandUpdateActionHandler,
  brandDeleteActionHandler,
  brandFetchByIdActionHandler,
} from "../inventory/settings/brand";

import {
  nameFetchActionHandler,
  nameCreateActionHandler,
  nameUpdateActionHandler,
  nameDeleteActionHandler,
  nameFetchByIdActionHandler,
} from "../inventory/settings/name";

import {
  unitFetchActionHandler,
  unitCreateActionHandler,
  unitUpdateActionHandler,
  unitDeleteActionHandler,
  unitFetchByIdActionHandler,
} from "../inventory/settings/unit";

import {
  quotaFetchActionHandler,
  quotaCreateActionHandler,
  quotaUpdateActionHandler,
} from "./settings/quota";

import {
  officeFetchActionHandler,
  officeCreateActionHandler,
  officeUpdateActionHandler,
  officeDeleteActionHandler,
} from "./roomConfiguration/office";

import {
  fetchBuilding,
  fetchBuildingDetailsDetails,
  createBuilding,
  updateBuilding,
  deleteBuilding,
} from "./roomConfiguration/building";

import {
  fetchRoomTypes,
  fetchRoomTypesDetails,
  createRoomTypes,
  updateRoomTypes,
  deleteRoomTypes,
} from "./roomConfiguration/roomTypes";

import {
  fetchDesks,
  fetchDeskDetails,
  createDesk,
  updateDesk,
  deleteDesk,
} from "./roomConfiguration/desk";

import {
  fetchRoom,
  fetchRoomDetails,
  createRoom,
  updateRoom,
  deleteRoom,
} from "./roomConfiguration/room";

import {
  fetchRoomConferences,
  fetchRoomConferenceDetails,
  createRoomConference,
  updateRoomConference,
} from "./roomConference/roomConference";

import {
  fetchBudgets,
  createBudget,
  updateBudget,
  deleteBudget,
  fetchBudgetById,
} from "./budget/budget";
import { fetchWarranties } from "./warranty/warranty";
import {
  fetchMaintenances,
  fetchMaintenanceDetails,
  createMaintenance,
  updateMaintenance,
} from "./maintenance/maintenance";
import { fetchForecasting } from "./forecasting/forecasting";

import {
  fetchProcurements,
  fetchProcurement,
  createProcurement,
} from "./procurements/procurements";

import {
  fetchSoftwareInventories,
  fetchSoftwareInventory,
  updateSoftwareInventory,
} from "./softwareInventory/software-inventory";

const inventoryActionsHandlers = {
  categoryListActionHandler,
  updateCategoryActionHandler,
  deleteCategoryActionHandler,
  createCategoryActionHandler,
  fetchCategoryByIdActionHandler,

  groupFetchActionHandler,
  groupCreateActionHandler,
  groupUpdateActionHandler,
  groupDeleteActionHandler,
  groupFetchByIdActionHandler,

  conditionListActionHandler,
  updateConditionActionHandler,
  deleteConditionActionHandler,
  createConditionActionHandler,

  brandFetchActionHandler,
  brandCreateActionHandler,
  brandUpdateActionHandler,
  brandDeleteActionHandler,
  brandFetchByIdActionHandler,

  nameFetchActionHandler,
  nameCreateActionHandler,
  nameUpdateActionHandler,
  nameDeleteActionHandler,
  nameFetchByIdActionHandler,

  unitFetchActionHandler,
  unitCreateActionHandler,
  unitUpdateActionHandler,
  unitDeleteActionHandler,
  unitFetchByIdActionHandler,

  quotaFetchActionHandler,
  quotaCreateActionHandler,
  quotaUpdateActionHandler,

  officeFetchActionHandler,
  officeCreateActionHandler,
  officeUpdateActionHandler,
  officeDeleteActionHandler,

  fetchBuilding,
  fetchBuildingDetailsDetails,
  createBuilding,
  updateBuilding,
  deleteBuilding,

  fetchRoomTypes,
  fetchRoomTypesDetails,
  createRoomTypes,
  updateRoomTypes,
  deleteRoomTypes,

  fetchDesks,
  fetchDeskDetails,
  createDesk,
  updateDesk,
  deleteDesk,

  fetchRoom,
  fetchRoomDetails,
  createRoom,
  updateRoom,
  deleteRoom,

  fetchRoomConferences,
  fetchRoomConferenceDetails,
  createRoomConference,
  updateRoomConference,

  fetchBudgets,
  fetchBudgetById,
  createBudget,
  updateBudget,
  deleteBudget,

  fetchWarranties,

  fetchMaintenances,
  fetchMaintenanceDetails,
  createMaintenance,
  updateMaintenance,

  fetchForecasting,

  fetchProcurements,
  createProcurement,
  fetchProcurement,

  fetchSoftwareInventories,
  fetchSoftwareInventory,
  updateSoftwareInventory,

  fetchEmployees,
  fetchEmployee,
  fetchEmployeeGeneralInfoActionHandler,
  fetchEmployeeAssetsActionHandler,
  assignEmployeeDeskOrBedActionHandler,

  distributionFetchActionHandler,
  itemsFetchActionHandler,
  fetchStockAssets,
  fetchStockProductList,

  fetchItemsList,

  fetchRequisitions,
  createRequisition,
  fetchRequisition,
  approveRequisition,
  assignRequisition,

  fetchAssets,
};

export default inventoryActionsHandlers;
